/**
 * Handles comma-formatted numeric input (for price, gap fields).
 * Allows only digits and commas, auto-formats with thousand separators.
 */
export const handleCommaNumberInput = (e, setter) => {
    const value = e.target.value;
    if (/^[0-9,]*$/.test(value)) {
        const numericValue = value.replace(/,/g, '');
        if (numericValue) {
            setter(numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        } else {
            setter('');
        }
    }
};

/**
 * Handles integer-only input (for household, years fields).
 * Allows only digits.
 */
export const handleIntegerInput = (e, setter) => {
    const value = e.target.value;
    if (/^[0-9]*$/.test(value)) {
        setter(value);
    }
};

/**
 * Handles decimal number input (for area field).
 * Allows digits and a single decimal point.
 */
export const handleDecimalInput = (e, setter) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
        setter(value);
    }
};

/**
 * Converts a price value in 만원 to a human-readable format (억원/만원).
 * @param {string|number} value - Price value in 만원
 * @returns {string} Formatted price string
 */
export const formatPriceDisplay = (value) => {
    if (!value) return '';
    const numericValue = typeof value === 'string' ? value.replace(/,/g, '') : value.toString();
    const numberValue = parseInt(numericValue, 10);
    if (isNaN(numberValue)) return '';

    if (numberValue >= 10000) {
        const billions = Math.floor(numberValue / 10000);
        const remainder = numberValue % 10000;
        if (remainder === 0) {
            return `${billions}억원`;
        }
        const millions = Math.round(remainder / 1000) * 1000;
        return `${billions}억 ${millions.toLocaleString()}만원`;
    }
    return `${numberValue.toLocaleString()}만원`;
};
